import { render, staticRenderFns } from "./LiveDetail.vue?vue&type=template&id=51a07ee5"
import script from "./LiveDetail.vue?vue&type=script&lang=js"
export * from "./LiveDetail.vue?vue&type=script&lang=js"
import style0 from "./LiveDetail.vue?vue&type=style&index=0&id=51a07ee5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports